import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import PageLayout from 'v2/layout/PageLayout/PageLayout';
import NotFound from 'v2/pages/GeneralErrors/NotFound';
import { areCloudControllersEnabled } from 'v2/utils/areCloudControllersEnabled';
import AllDevices from './AllDevices/AllDevices';
import CloudControllers from './CloudControllers/CloudControllers';
import CloudControllerDetails from './CloudControllers/Details/CloudControllerDetails';
import DeviceDetails from './DeviceDetails/DeviceDetails';
import DeviceGroupDetails from './DeviceGroups/Details/DeviceGroupDetails';
import DeviceGroups from './DeviceGroups/DeviceGroups';

const Devices: React.FC<React.PropsWithChildren> = () => (
  <PageLayout>
    <Routes>
      <Route path="/overview" element={<AllDevices />} />
      {areCloudControllersEnabled() && <Route path="/cloud-controllers" element={<CloudControllers />} />}
      {areCloudControllersEnabled() && (
        <Route path="/cloud-controllers/:cloudControllerId" element={<CloudControllerDetails />} />
      )}
      <Route path="/:deviceId" element={<DeviceDetails />} />
      <Route path="/groups" element={<DeviceGroups />} />
      <Route path="/groups/:groupId" element={<DeviceGroupDetails />} />
      <Route path="/" element={<Navigate to="overview" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </PageLayout>
);

export default Devices;
